import PublicShell, { LegalPage, LegalSection } from "@/components/PublicShell";
import { SITE } from "@/lib/siteInfo";

export default function Refunds() {
  return (
    <PublicShell testId="refunds-page">
      <LegalPage
        title="Refund & Cancellation Policy"
        subtitle="How Premium billing, cancellations and refunds work on Sliply. This policy forms part of our Terms of Service."
        updated={SITE.effectiveDate}
        testId="refunds-content"
      >
        <LegalSection n="1" title="The Free plan">
          <p>Sliply's Free plan is free forever and requires no payment or card details. You can use it as long as you like, and the sections below only apply once you upgrade to a paid Premium subscription.</p>
        </LegalSection>

        <LegalSection n="2" title="Premium billing">
          <p>Premium is billed in advance per cycle (monthly or yearly) and renews automatically at the end of each cycle until you cancel. All prices are in South African Rand (ZAR) and include VAT where applicable. We will show the amount and the next renewal date before you pay.</p>
        </LegalSection>

        <LegalSection n="3" title="Cooling-off on your first payment">
          <p>In line with the Consumer Protection Act, if you are a first-time subscriber you may request a full refund within <strong>7 days</strong> of your first Premium payment, provided the service has not been substantially consumed (for example, heavy use of Premium-only features such as bulk exports). This cooling-off right applies to your initial purchase only.</p>
        </LegalSection>

        <LegalSection n="4" title="Refunds after the cooling-off period">
          <p>Outside the 7-day window, Premium fees are generally <strong>non-refundable</strong>, including for partially used billing periods. We may, at our discretion, issue a full or pro-rata refund in cases such as a confirmed billing error, a duplicate charge, or a prolonged service failure on our side. Refunds are made to the original payment method and typically settle within 5–10 business days, depending on your bank or payment provider.</p>
        </LegalSection>

        <LegalSection n="5" title="How to cancel">
          <p>You can cancel your Premium subscription at any time:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li><strong>Self-service:</strong> in the app, open <em>Settings → Subscription</em> and choose <em>Cancel Premium</em>.</li>
            <li><strong>By email:</strong> write to <a href={`mailto:${SITE.email}`} className="text-riq-primary font-semibold hover:underline">{SITE.email}</a> from your account email and we'll cancel it for you.</li>
          </ul>
          <p>When you cancel, you keep Premium access until the end of the current paid period — we don't cut you off mid-cycle. Your plan then reverts to Free; it does not renew again.</p>
        </LegalSection>

        <LegalSection n="6" title="What happens to your data after cancellation">
          <p>When you drop to the Free plan, your account and receipts remain intact — you simply lose access to Premium-only features (such as warranties, trips, Ask AI and PDF/VAT exports) until you upgrade again.</p>
          <p>If you want your account and data deleted entirely, email us from your account address and we will delete your personal data within 30 days, except where we are required to retain limited records by law. Deletion is permanent and cannot be undone.</p>
        </LegalSection>

        <LegalSection n="7" title="Failed or disputed payments">
          <p>If a renewal payment fails, we may retry it and will notify you. If payment cannot be collected, Premium access is paused and your plan reverts to Free. If you believe you were charged in error, contact us within 30 days and we'll investigate promptly.</p>
        </LegalSection>

        <LegalSection n="8" title="Contact us">
          <p>
            For any billing, cancellation or refund request, email <a href={`mailto:${SITE.email}`} className="text-riq-primary font-semibold hover:underline">{SITE.email}</a>
            {SITE.phone ? <> or call {SITE.phone}</> : null}. We usually reply within 1 business day.
            {SITE.address ? <><br />{SITE.legalName}, {SITE.address}</> : null}
          </p>
        </LegalSection>
      </LegalPage>
    </PublicShell>
  );
}
